export class s3 {
    constructor() {
    }

    static generateS3Key(filename) {
        let file = `${Date.now()}-${filename}`;
        file = file.replace(/\s/g, "");
        return file;
    }
}